import(/* webpackMode: "eager" */ "/Users/subhrajitbhowmik/Downloads/ecom/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"]}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/Users/subhrajitbhowmik/Downloads/ecom/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/subhrajitbhowmik/Downloads/ecom/src/components/auth-wrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/Users/subhrajitbhowmik/Downloads/ecom/src/providers/ClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/Users/subhrajitbhowmik/Downloads/ecom/src/providers/QueryProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SocketProvider"] */ "/Users/subhrajitbhowmik/Downloads/ecom/src/providers/SocketProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/Users/subhrajitbhowmik/Downloads/ecom/src/providers/ThemeProvider.tsx");
